import { emptyArray } from 'vet-bones/constants';
import { SelectItem, stringToSelectItem } from 'vet-bones/utils/select';

import { ReduxState } from 'src/store/types';

export const databaseItemsSelector = (state: ReduxState): SelectItem[] => {
  const databaseIds = state.databases.databaseIds.filter(
    (databaseId) => state.databases.databasesById?.[databaseId]?.isOnline
  );

  return databaseIds.length
    ? databaseIds.map(stringToSelectItem)
    : (emptyArray as any);
};
